module.exports = __webpack_public_path__ + "img/ekran9@2x.5d080ace.png";